































































































import { Component, Vue } from 'vue-property-decorator'

import { PagerData } from '@/libs/request/request'
import service, { GenealogyMember } from '@/api/genealogy/GenealogyMember'

import Note from '@/views/pages/genealogy/note/components/Note.vue'
import Avatar from '@/components/field/avatarUploader/avatar.vue'
import { getDefaultAvatar } from '@/ts/tool'

@Component({
  name: 'NoteTree',
  components: { Note, Avatar }
})
export default class extends Vue {
  query: any = {
    page: 1,
    pageSize: 1000,
    genealogyId: '',
    sorts: ['createTime']
  };

  loading: boolean = true;

  showNote: boolean = false;

  treeData: any = [];

  // 表格数据
  tabledata: PagerData<GenealogyMember> = {
    total: 0,
    items: []
  };

  notLink: any = [];
  scrollAble: boolean = false;

  created () {
    this.query.genealogyId = this.$route.query.id
    this.reloadData()
  }

  avatarHandle (item: any) {
    if (item && item.picture) return item.picture
    else {
      return getDefaultAvatar(item.gender)
    }
  }

  reloadData () {
    this.freshFromServer()
    this.loadNotLink()
  }

  loadNotLink () {
    service
      .getPagesOfGenealogyMemberNoParent({
        genealogyId: this.query.genealogyId,
        page: 1,
        pageSize: 1000,
        parentId: -1
      })
      .then((res) => {
        if (res.result) {
          this.notLink = res.result.items
        }
      })
  }

  freshFromServer (): void {
    this.fetchDataFromServer()
  }

  fetchDataFromServer (
    curPage: number | undefined = undefined,
    pageSize: number | undefined = undefined
  ) {
    if (curPage) {
      this.query.page = curPage
    }
    if (pageSize) {
      this.query.pageSize = pageSize
    }
    let loading = this.$Loading
    loading.start()
    this.loading = true
    service
      .getPagesOfGenealogyMember(this.query)
      .then((pagers) => {
        this.tabledata = pagers.result!
        if (this.tabledata.items && this.tabledata.items.length > 0) {
          if (this.query.nameLk) {
            // 带条件查询
            this.tabledata.items.forEach((v) => {
              v.parentId = 0
            })
          }
          this.treeData = this.treeDataHandle(0)
        }
      })
      .catch((err) => {
        this.$Message.error(err.message)
      })
      .finally(() => {
        loading.finish()
        this.loading = false
        this.showNote = true
        this.$nextTick(() => {
          const parentEl = this.$refs.container as Element
          const childEl = this.$refs.content as Element
          if (childEl && parentEl) {
            const parentRect = parentEl.getBoundingClientRect()
            const childRect = childEl.getBoundingClientRect()
            this.scrollAble = childRect.width > parentRect.width
            if (this.scrollAble) {
              parentEl.scrollLeft = childRect.width - parentRect.width
            }
            return
          }
          this.scrollAble = false
        })
      })
  }

  treeDataHandle (parentId?: any) {
    let arr: any = []
    this.tabledata.items.forEach((v: any) => {
      if (v.parentId === parentId) {
        v.children = this.treeDataHandle(v.id)
        v.isOpen = true
        v.hasChild = v.children && v.children.length > 0
        arr.push(JSON.parse(JSON.stringify(v)))
      }
    })
    return arr
  }

  activeId: any = -1;
  activeItem: any = {};

  addTo (item: any) {
    if (!this.treeData || this.treeData.length < 1) {
      item.parentId = 0
    } else {
      if (!this.activeId || this.activeId < 0) {
        this.$Message.error('请先选择一个节点！')
        return
      }
      item.parentId = this.activeId
      console.log(this.activeId)
    }
    console.log(item)
    this.loading = true
    this.showNote = false
    service.updateOneGenealogyMember(item).then(() => {
      this.reloadData()
    })
  }

  active (item: any) {
    console.log(item)
    this.activeItem = item
    this.activeId = item.id
  }

  touchMask () {
    this.activeItem = null
    this.activeId = null
  }

  removeThis (item: any) {
    this.$Modal.confirm({
      title: '确定要删除吗',
      onOk: () => {
        if (item.children && item.children.length > 0) {
          this.$Message.error('该节点存在下级，无法删除！')
        } else {
          item.parentId = -1
          this.loading = true
          this.showNote = false
          service.updateOneGenealogyMember(item).then(() => {
            this.activeId = -1
            this.activeItem = {}
            this.reloadData()
          })
        }
      }
    })
  }
}
